import { render } from "./NcrmPrivacyActivityCard.vue?vue&type=template&id=607472b5&scoped=true"
import script from "./NcrmPrivacyActivityCard.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyActivityCard.vue?vue&type=script&lang=js"

import "./NcrmPrivacyActivityCard.vue?vue&type=style&index=0&id=607472b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607472b5"]])

export default __exports__